import { React, useEffect } from 'react';
import { NavLink, useLocation, useParams, useSearchParams } from 'react-router-dom';

import { IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import InventoryIcon from '@mui/icons-material/Inventory2';
import GroupIcon from '@mui/icons-material/Group';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import { logo, UserDropdown, GlobalSearch, Error404 } from '.'

import '../css/principal_styles.css';
import "../css/empresas.css";

import { HomeHosming } from '../pages/HomeHosming';
import imagen_mantenimiento from "../images/mantenimiento.png";

import { Empresas } from '../pages/empresas';
import SearchResults from '../pages/Hosming/SearchResults';
// import Menu_Usuario from './Menu_Usuario';
import GlobalProducts from '../pages/GlobalProducts';
import { useProovedorData } from '../components';
import { ModalLogin } from './global/ModalLogin';
import { VideosHosming } from '../pages/Hosming/VideosHosming';

export const NavbarHosming = () => {
  const styles_icon_nav = { color: 'var(--empresa-color)', fontSize: 'var(--fon-icons)' };
  const { main_direc } = useParams();

  const { showLogin, setShowLogin, data_user } = useProovedorData() || [];

  const returnPage = () => {
    const textDirectory = main_direc ?? "";
    var selected = null;

    switch (textDirectory) {
      case "":
        selected = <HomeHosming />
        // selected = <Main_Page />;
        break;

      case "products":
        selected = <GlobalProducts />
        break;

      case "company":
        selected = <Empresas />
        break;

      case "videos":
        selected = <VideosHosming />
        break;

      case "results":
        selected = <SearchResults />
        break;

      // case "user":
      //   selected = <Menu_Usuario subMenu={get_main[2] ?? "information"} authCode={parametro ?? "me"} />;
      //   break;

      default:
        selected = (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center', justifyContent: 'center', textAlign: 'center', width: '100%', padding: '15px' }}>
            <img src={imagen_mantenimiento} style={{ minWidth: '300px', width: '350px', maxWidth: '600px' }} />
            <h2 className='h2-mant'>
              Bienvenido...
            </h2>

            <p className='p-mant'>
              Nuestro sitio web está en construcción, estamos trabajando muy duro para brindarle la mejor experiencia con este.
            </p>
          </div>
        );
        break;
    }

    return selected;
  }

  return (
    <>
      <nav className='nav-company'>
        <div className='nav-d1'>
          <NavLink
            to="/"
            className='nav-logo'
          >
            <img src={logo} alt="Logo de Hosming" />
          </NavLink>
        </div>

        <div className='nav-d2'>
          <ul>
            <li>
              <NavLink to="/" className={({ isActive }) => isActive ? 'option-active' : ''} style={{ border: 'none' }}>
                <IconButton>
                  <HomeIcon className='li-icon' style={{ color: 'var(--empresa-color)' }} />
                </IconButton>
              </NavLink>
            </li>

            <li className='no-phone'>
              <NavLink to="/products" className={({ isActive }) => isActive ? 'option-active' : ''}>
                <IconButton>
                  <InventoryIcon className='li-icon' style={{ color: 'var(--empresa-color)' }} />
                </IconButton>
              </NavLink>
            </li>

            <li className='no-phone'>
              <NavLink to="/company" className={({ isActive }) => isActive ? 'option-active' : ''}>
                <IconButton>
                  <GroupIcon className='li-icon' style={{ color: 'var(--empresa-color)' }} />
                </IconButton>
              </NavLink>
            </li>

            <li>
              <NavLink to="/videos/long" className={({ isActive }) => isActive ? 'option-active' : ''}>
                <IconButton>
                  <PlayCircleIcon className='li-icon' style={{ color: 'var(--empresa-color)' }} />
                </IconButton>
              </NavLink>
            </li>

            <li className='only-phone'>
              <NavLink to="/videos/shorts" className={({ isActive }) => isActive ? 'option-active' : ''}>
                <IconButton>
                  <PlayCircleOutlineIcon className='li-icon' style={{ color: 'var(--empresa-color)' }} />
                </IconButton>
              </NavLink>
            </li>
          </ul>

          <GlobalSearch colorIcons={"hosming"} handleModa={() => { }} />

          <UserDropdown handleModal={setShowLogin} />
        </div>
      </nav>

      {returnPage()}

      <ModalLogin stateModal={showLogin && (data_user?.authCode == null ? true : false)} handleModal={setShowLogin} />
    </>
  )
}
